//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'base-layout-page-header',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    parentPath () {
      const segments = this.$route.path
        .split('/')
        .filter(Boolean);

      segments.pop();

      while (segments.length) {
        const path = `/${segments.join('/')}`;
        const route = this.$router.match(path);

        if (route.matched.length) return path;

        segments.pop();
      }

      return '/';
    },
  },
};
